module.exports = __webpack_public_path__ + "static/media/icon-instagram.7c6e51dc.svg";